import React from "react";
import {
  Box,
  Typography,
  Button,
  Card,
  CardMedia,
  CardContent,
  useTheme,
} from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import image1 from "../../assets/lagooncleaning/lagoon2.jpeg";
import image2 from "../../assets/neerataping/neera1.jpeg";
import image3 from "../../assets/foodweb/food1.jpeg";
import image4 from "../../assets/RisingSea.jpeg";
import image5 from "../../assets/img12.jpeg";
import image6 from "../../assets/img13.jpeg";
import image7 from "../../assets/img14.jpeg";
import image8 from "../../assets/img15.jpeg";
import image9 from "../../assets/img16.jpeg";
import image10 from "../../assets/img17.jpeg";
import image11 from "../../assets/img18.jpeg";
import image12 from "../../assets/img19.jpeg";
import { useNavigate } from "react-router-dom";

const featureData = [
  {
    title: "Lagoon Cleaning Drive at Androth Island",
    image: image1,
    link: "/lagoon-cleaning",
  },
  {
    title: "REEF Promotes Indigenous Knowledge of Neera Tapping",
    image: image2,
    link: "/neera-tapping",
  },
  {
    title:
      "Students Engage in Food Chain Cycle Activity with REEF to Explore Ecosystem Balance",
    image: image3,
    link: "/food-web",
  },
  {
    title:
      "Rising Sea Levels: REEF Inspires Young Minds at Kendriya Vidyalaya, Kavaratti",
    image: image4,
    link: "/rising-sea",
  },
  // {
  //   title: "Voices of the Future",
  //   image: image4,
  //   link: "/future-voices",
  // },
  // {
  //   title: "Public Speech Competition",
  //   image: image5,
  //   link: "/public-speech",
  // },
  // {
  //   title: "Young Voices for a Rising Cause",
  //   image: image6,
  //   link: "/young-voices",
  // },
  // {
  //   title: "Cartoon Competition",
  //   image: image7,
  //   link: "/cartoon-compeition",
  // },
  // {
  //   title: "Humor Meets Hard Truths",
  //   image: image8,
  //   link: "/humour-meets",
  // },
  // {
  //   title: "Painting Competition",
  //   image: image9,
  //   link: "/painting-compeition",
  // },
  // {
  //   title: "Painting the Climate Crisis",
  //   image: image10,
  //   link: "/climate-crisis",
  // },
  // {
  //   title: "Art Reflects the Ocean’s Struggle",
  //   image: image11,
  //   link: "/ocean-struggles",
  // },
  // {
  //   title: "A Vibrant Step Towards Awareness",
  //   image: image12,
  //   link: "/reef-leads",
  // },
];

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 640 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 640, min: 0 },
    items: 1,
  },
};

export default function FeaturesCarousel() {
  const navigate = useNavigate();

  return (
    <Box sx={{ bgcolor: "#ffff", py: 8, px: { xs: 2, sm: 4, md: 10 } }}>
      <Box sx={{ maxWidth: "1440px", mx: "auto" }}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={4}
        >
          <Typography
            variant="h4"
            color="black"
            fontWeight="bold"
            sx={{ fontFamily: "Montserrat, sans-serif" }}
          >
            FEATURES
          </Typography>
          <Button
            variant="outlined"
            endIcon={<ArrowForwardIcon />}
            sx={{
              color: "white",
              borderColor: "white",
              borderRadius: "4px",
              fontFamily: "Montserrat, sans-serif",
              fontWeight: 600,
            }}
            onClick={() => navigate("/features")}
          >
            VIEW ALL
          </Button>
        </Box>
        <Carousel
          swipeable
          draggable
          showDots
          arrows={false}
          responsive={responsive}
          infinite
          autoPlay={false}
          keyBoardControl
          customTransition="transform 700ms ease-in-out"
          transitionDuration={700}
          containerClass="carousel-container"
          dotListClass="custom-dot-list-style"
          itemClass="carousel-item-padding-40-px"
        >
          {featureData.map((item, index) => (
            <Card
              key={index}
              sx={{
                mx: 1,
                height: "100%",
                display: "flex",
                flexDirection: "column",
                boxShadow: 0,
                backgroundColor: "#fff",
                cursor: "pointer",
              }}
              onClick={() => navigate(item.link)}
            >
              <CardMedia
                component="img"
                image={item.image}
                alt={item.title}
                sx={{
                  height: 250,
                  objectFit: "cover",
                  transition: "transform 0.5s ease",
                  "&:hover": {
                    transform: "scale(1.1)",
                  },
                }}
              />

              <CardContent sx={{ flexGrow: 1 }}>
                <Typography
                  variant="h6"
                  fontWeight="bold"
                  color="#1A1A1A"
                  sx={{ fontFamily: "Montserrat, sans-serif" }}
                >
                  {item.title}
                </Typography>
                <Typography
                  variant="body2"
                  color="green"
                  mt={2}
                  sx={{
                    textDecoration: "underline",
                    fontFamily: "Montserrat, sans-serif",
                  }}
                >
                  Read More
                </Typography>
              </CardContent>
            </Card>
          ))}
        </Carousel>
      </Box>
    </Box>
  );
}
